import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { Button, Heading, Text } from '@frontend/design-system';
import { CardProps } from './types';

const cardDivStyle1 = css`
  border: ${`1px solid ${theme.colors.neutral20}`};
  border-radius: ${theme.borderRadius.medium};
  width: 320px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
`;

const cardImgStyle2 = css`
  border-radius: ${`${theme.borderRadius.medium} ${theme.borderRadius.medium} 0 0`};
`;

const cardDivStyle3 = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: ${theme.spacing(3)};
  padding: ${theme.spacing(3)};
  border-top: ${`1px solid ${theme.colors.neutral20}`};
`;

const cardButtonStyle4 = css`
  font-weight: ${theme.font.weight.bold};
`;

export const Card = ({ buttonText, description, imgSrc, onClick, title, trackingId }: CardProps) => (
  <div className={cardDivStyle1} onClick={onClick} data-trackingid={trackingId}>
    <img src={imgSrc} alt={title} className={cardImgStyle2} />
    <div className={cardDivStyle3}>
      <Heading level={2}>{title}</Heading>
      <Text>{description}</Text>
      <Button variant='secondary' size='small' className={cardButtonStyle4}>
        {buttonText}
      </Button>
    </div>
  </div>
);
